import filters from '../filters'

/**
 * Global mixins
 *
 * - Included in every view and component by default.
 */
export default {
  computed: {
    // Include global data
    global: function () { return this.$store.state.data }
  },

  /**
   * Import filters
   */
  filters
}



// WEBPACK FOOTER //
// ./app/src/mixins/global.js